// FeatureService.js
import React from 'react';
import './serviceoffer.css'

interface offerServiceProps {
  data: {
    image: string;
    title: string;
    subtitle: string;
  };
}

const offerService: React.FC<offerServiceProps> = ({ data }) => {
  return (
    <div className=" offer-service feature-services-wrap">
      <div className=" offer-service-img feature-service-img">
        <img src={data.image} alt="Feature Service" />
      </div>
      <div className="offer-service-desc feature-service-desc">
        <h3>{data.title}</h3>
        <h5>{data.subtitle}</h5>
      </div>
    </div>
  );
};

export default offerService;
